'use strict';

angular.module('app.addNewNetwork', [])
	.controller('addNewNetworkCtrl', ['$scope', '$rootScope', '$http', '$modal', '$location', '$modalInstance', 'addNewNetworkService', 'accountDetailsService',
		function ($scope, $rootScope, $http, $modal, $location, $modalInstance, addNewNetworkService, accountDetailsService) {

	    	var definitions = angular.copy($rootScope.definitions);
    		$scope.countries = definitions.countries;

        $scope.searchCountries = function(event) {
	        if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
	            for(var i = 0; i < $scope.countries.length; i++) {
	                if($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
	                    var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
	                    var item = checkbox.find('label')[i];
	                    checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
	                    break;
	                }
	            }
	        }
	    }

	    $scope.addNewNetwork = function () {
	        $scope.selectedCountryId = "";
	        $scope.countries.forEach(function (val) {
	            if (val.ticked === true) {
	                $scope.selectedCountryId = val.id;
	            }    
	        });

	        var params = {
	            name: $scope.name,
	            country: $scope.selectedCountryId,
	            address: $scope.contact,
	            phone: $scope.phone,
	            contact_email: $scope.email
	        }

	        addNewNetworkService.addNewNetwork(params, true)
	        	.then(function(response) {
	        		var influencerAccountData = {
		                accountId: null,
		                accountType: 5,
		                vat: null,
		                accountName: $scope.name,
		                mailingStreet: null,
		                mailingCity: null,
		                mailingZipCode: null,
		                mailingCountry: $scope.selectedCountryId,
		                isDiffAddress: 0,
		                billingStreet: null,
		                billingCity: null,
		                billingZipCode: null,
		                billingCountry: $scope.selectedCountryId,
		                governingAgency: null,
		                contactPersonId: null,
		                contactPersonName: $scope.contact,
		                contactPersonPhone: $scope.phone,
		                contactPersonEmail: $scope.email,
		                autoCreateAccountForInfluencerOrNetwork: true,
		                influencerId: null,
		                networkId: response.data.id,
		                isActive: 2
		            }    

		            createAccountService.createAccount(influencerAccountData, true)
		                .then(function(response) {
		                    
		                }, function(response) {
		                    var errorModalInstance = $modal.open({
		                        scope: $scope,
		                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                        windowClass: 'modal-dialog-mention-error'
		                    });
		                    $scope.errorModalInstance = errorModalInstance;
		                    $scope.errorMessage = response.message;
		                })

		            $modalInstance.close(function () {
		                $log.info('Close Modal now');
		            })

		            location.reload('admin/networks');   
	        	}, function(response) {
	        		var errorModalInstance = $modal.open({
	                    scope: $scope,
	                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
	                    windowClass: 'modal-dialog-mention-error'
	                });
	                $scope.errorModalInstance = errorModalInstance;
	                $scope.errorMessage = response.message;
	        	})
	    }
}])